(() => {
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-ic-carousel]').forEach(carousel => {
      if (carousel.dataset.icBound) return;
      carousel.dataset.icBound = 'true';
      const track = carousel.querySelector('[data-ic-track]');
      if (!track || !track.children.length) return;
      const items = [...track.children];
      const dots = [...carousel.querySelectorAll('[data-ic-slide]')];
      const previous = carousel.querySelector('[data-ic-prev]');
      const next = carousel.querySelector('[data-ic-next]');
      const status = carousel.querySelector('[data-ic-carousel-status]');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      const left = index => items[index].offsetLeft - items[0].offsetLeft;
      const current = () => items.reduce((best, item, index) => Math.abs(left(index) - track.scrollLeft) < Math.abs(left(best) - track.scrollLeft) ? index : best, 0);
      const move = index => track.scrollTo({ left: left(Math.max(0, Math.min(index, items.length - 1))), behavior: reduced.matches ? 'instant' : 'smooth' });
      const step = direction => {
        const visible = Math.max(1, Math.floor((track.clientWidth + 1) / items[0].getBoundingClientRect().width));
        let index = current() + direction * visible;
        if (carousel.hasAttribute('data-ic-loop')) {
          if (direction > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 3) index = 0;
          if (direction < 0 && track.scrollLeft < 3) index = items.length - 1;
        }
        move(index);
      };
      if (carousel.hasAttribute('data-ic-autoplay') && items.length > 1) {
        let paused = reduced.matches;
        let hovering = false;
        const pause = carousel.querySelector('[data-ic-pause]');
        const syncPause = () => { pause?.setAttribute('aria-pressed', String(paused)); pause?.setAttribute('aria-label', paused ? 'Resume banner rotation' : 'Pause banner rotation'); };
        pause?.addEventListener('click', () => { paused = !paused; syncPause(); });
        carousel.addEventListener('mouseenter', () => hovering = true);
        carousel.addEventListener('mouseleave', () => hovering = false);
        track.addEventListener('pointerdown', () => { paused = true; syncPause(); });
        reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; syncPause(); } });
        const timer = setInterval(() => {
          if (!carousel.isConnected) { clearInterval(timer); return; }
          if (!paused && !hovering && !document.hidden && !carousel.contains(document.activeElement)) step(1);
        }, 7000);
        syncPause();
      }
      previous?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));
      dots.forEach(dot => dot.addEventListener('click', () => move(Number(dot.dataset.icSlide))));
      const update = () => {
        const index = current();
        dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        const overflow = track.scrollWidth > track.clientWidth + 3;
        if (previous) { previous.hidden = !overflow; previous.disabled = !carousel.hasAttribute('data-ic-loop') && track.scrollLeft < 3; }
        if (next) { next.hidden = !overflow; next.disabled = !carousel.hasAttribute('data-ic-loop') && track.scrollLeft >= track.scrollWidth - track.clientWidth - 3; }
        if (status) status.textContent = overflow ? `${index + 1} / ${items.length}` : '';
      };
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
